import { render, staticRenderFns } from "./detailsGoods.vue?vue&type=template&id=135b3393&scoped=true&"
import script from "./detailsGoods.vue?vue&type=script&lang=js&"
export * from "./detailsGoods.vue?vue&type=script&lang=js&"
import style0 from "./detailsGoods.vue?vue&type=style&index=0&id=135b3393&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b3393",
  null
  
)

export default component.exports